export default __webpack_public_path__ + "static/media/app-analysis-2.9795bf5b.jpg";